module.exports = __webpack_public_path__ + "img/2-2.fd602cf3.png";